module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/day01_01_stay-79928b1b092e553abce767cca395e014.jpg";